import React from "react";

export function TrendUp01() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.6666 4.6665L9.42083 9.91226C9.15682 10.1763 9.02482 10.3083 8.8726 10.3577C8.7387 10.4012 8.59447 10.4012 8.46057 10.3577C8.30836 10.3083 8.17635 10.1763 7.91234 9.91226L6.0875 8.08742C5.82349 7.82341 5.69148 7.6914 5.53926 7.64194C5.40537 7.59844 5.26114 7.59844 5.12724 7.64194C4.97502 7.6914 4.84302 7.82341 4.579 8.08742L1.33325 11.3332M14.6666 4.6665H9.99992M14.6666 4.6665V9.33317"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
